import React from "react"

import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import PriorityMultiselectValueNotEmpty from "../components/multiselect/value-not-empty"
import PriorityMultiselectPopoverOption from "../components/multiselect/popover-option"
import FieldProto_AutomationConditionForm from "../../../proto/render/automation/automation-condition-form";

export default class FieldPriority_AutomationConditionForm extends FieldProto_AutomationConditionForm {
    render() {
        return (
            <div className="flex-row-left-top">
                <div className="label">is</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.config.fieldValues}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {PriorityMultiselectValueNotEmpty}
                                       popoverOptionComponent           = {PriorityMultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeFieldValues}/>
            </div>
        )
    }
}
